'use client'

import { motion } from 'framer-motion'

export function MotionDiv({ children, ...props }) {
  return <motion.div {...props}>{children}</motion.div>
}

export function MotionSpan({ children, ...props }) {
  return <motion.span {...props}>{children}</motion.span>
} 